<template lang="pug">
    simple-modal-layout.generic-confirmation-modal(v-bind="$attrs" :confirmButtonText="confirmButtonText" cancelButtonText="Cancel" @approve="onApprove")
        template(v-slot:section) {{ text }}
</template>

<script>
export default {
    name: 'generic-confirmation-modal',
    props: {
        text: {
            type: String,
            required: true,
        },
        approve: {
            type: Function,
            required: true,
        },
        confirmButtonText: {
            type: String,
            default: 'Yes',
        },
    },
    methods: {
        onApprove({success}) {
            success()
            this.approve()
        },
    },
}
</script>
